import TempleMarket from './templeMarket'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...TempleMarket
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/templeManage/index.js